module.exports = __webpack_public_path__ + "onset-instructions-2.gif?0df6bdd8f7edb9d3c80a775d02fb821c";